module.exports = __webpack_public_path__ + "img/mariela-garcia-dominguez.9bdb9ab3.jpg";